import React from 'react';
export function IngredientsSection() {
  return <section className="bg-background py-16 sm:py-24" data-id="element-371">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-372">
        <div className="text-center mb-12" data-id="element-373">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-374">
            Ingredientes Clave de Trimora
          </h2>
          <p className="mt-3 text-muted-foreground text-lg max-w-xl mx-auto" data-id="element-375">
            Seleccionados por su eficacia y respaldo científico.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-376">
          {/* Moringa */}
          <div className="bg-card rounded-xl p-6 shadow-sm border border-border flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow duration-200" data-id="element-377">
            <span className="text-4xl" data-id="element-378">🌿</span>
            <h3 className="text-lg font-bold text-foreground" data-id="element-379">Moringa</h3>
            <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-380">
              Apoyo al equilibrio metabólico. Rica en nutrientes esenciales y
              antioxidantes naturales.
            </p>
          </div>

          {/* Té verde */}
          <div className="bg-card rounded-xl p-6 shadow-sm border border-border flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow duration-200" data-id="element-381">
            <span className="text-4xl" data-id="element-382">🍃</span>
            <h3 className="text-lg font-bold text-foreground" data-id="element-383">
              Extracto de Té Verde
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-384">
              Soporte termogénico natural. Favorece el metabolismo energético de
              forma suave y sostenida.
            </p>
          </div>

          {/* NAD+ */}
          <div className="bg-card rounded-xl p-6 shadow-sm border border-border flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow duration-200" data-id="element-385">
            <span className="text-4xl" data-id="element-386">🧬</span>
            <h3 className="text-lg font-bold text-foreground" data-id="element-387">NAD+</h3>
            <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-388">
              Energía celular. Coenzima esencial para el metabolismo y la
              función celular óptima.
            </p>
          </div>

          {/* Probióticos */}
          <div className="bg-card rounded-xl p-6 shadow-sm border border-border flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow duration-200" data-id="element-389">
            <span className="text-4xl" data-id="element-390">🌱</span>
            <h3 className="text-lg font-bold text-foreground" data-id="element-391">Probióticos</h3>
            <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-392">
              Bienestar digestivo. Apoya el equilibrio de la microbiota
              intestinal para una mejor digestión.
            </p>
          </div>

          {/* Cúrcuma */}
          <div className="bg-card rounded-xl p-6 shadow-sm border border-border flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow duration-200 sm:col-span-2 lg:col-span-1" data-id="element-393">
            <span className="text-4xl" data-id="element-394">✨</span>
            <h3 className="text-lg font-bold text-foreground" data-id="element-395">Cúrcuma</h3>
            <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-396">
              Apoyo antioxidante. Contribuye a reducir el estrés oxidativo y
              apoya el bienestar general.
            </p>
          </div>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-8 max-w-2xl mx-auto" data-id="element-397">
          * Todos los ingredientes son de origen natural. Trimora es un
          complemento alimenticio, no un medicamento.
        </p>
      </div>
    </section>;
}